import * as constants from '../../constants/Tickets'
import * as generalActions from '../../actions/generalActions'

export function toggleManualInput(useManualInput) {
    return {
        type: constants.USE_MANUAL_INPUT,
        useManualInput: useManualInput
    }
}

export function setBarcode(barcode) {
    return {
        type: constants.SET_BARCODE,
        barcode: barcode
    }
}

export function validatedTicket(result) {
    return {
        type: constants.VALIDATED_TICKET,
        validationResult: result
    }
}

export function clearValidationResult() {
    return {
        type: constants.CLEAR_VALIDATION
    }
}

export function clearBarcode() {
    return {
        type: constants.CLEAR_BARCODE
    }
}

export function allowAccess(posDeviceGuid, barcode, culture) {
    return function (dispatch, getState) {
        dispatch(generalActions.loadingStart());

        const overrideModal = getState().ticket.overrideModal;
        const selectedCustomer = overrideModal.customers.find(customer => customer.Selected);
        const articles = {};
        overrideModal.articles.forEach(article => articles[article.ArticleId] = article.SelectedQuantity);

        const data = {
            posDeviceGuid: posDeviceGuid,
            accessKey: barcode,
            culture: culture,
            overrideAccess: true,
            reference: overrideModal.reference,
            customerId: selectedCustomer && selectedCustomer.CustomerId,
            articles: articles,
            posId: getState().generalState.posId
        }

        fetch(`${constants.API_URL_VALIDATE_TICKET}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then(() => dispatch(generalActions.loadingEnd()));
    }
}

export function validateTicket(posDeviceGuid, barcode, culture) {
    return function (dispatch,getState) {
        dispatch(generalActions.loadingStart());
        const data = {
            posDeviceGuid: posDeviceGuid,
            accessKey: barcode,
            culture: culture,
            overrideAccess: false,
            posId: getState().generalState.posId
        }
        fetch(`${constants.API_URL_VALIDATE_TICKET}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
        .then(() => dispatch(generalActions.loadingEnd()));
    }
}

export function setOverrideModal(visible, onConfirm, onCancel) {
    return function (dispatch) {
        dispatch(internalSetOverrideModal(visible, onConfirm, onCancel));

        if (visible) {
            dispatch(fetchTicketArticles());
        }
    }
}

export function internalSetOverrideModal(visible, onConfirm, onCancel) {
    return {
        type: constants.SET_OVERRIDE_MODAL,
        data: {
            visible: visible,
            view: "article",
            onConfirm: onConfirm,
            onCancel: onCancel
        }
    }
}

export function setOverrideModalView(view) {
    return function (dispatch) {
        dispatch(internalSetOverrideModalView(view));

        if (view === "customer") {
            dispatch(fetchTicketCustomers());
        }
    }
}

export function internalSetOverrideModalView(view) {
    return {
        type: constants.SET_OVERRIDE_MODAL_VIEW,
        view: view
    }
}

export function setTicketReference(reference) {
    return {
        type: constants.SET_TICKET_REFERENCE,
        reference: reference
    }
}

function fetchTicketArticles() {
    return function (dispatch) {
        fetch(`${constants.API_URL_TICKET_ARTICLES}`)
            .then(generalActions.parseJSON)
            .then(data => dispatch(ticketArticlesFetched(data)));
    }
}

function ticketArticlesFetched(articles) {
    return {
        type: constants.TICKET_ARTICLES_FETCHED,
        articles: articles
    }
}

function fetchTicketCustomers() {
    return function (dispatch) {
        fetch(`${constants.API_URL_TICKET_CUSTOMERS}`)
            .then(generalActions.parseJSON)
            .then(data => dispatch(ticketCustomersFetched(data)));
    }
}

function ticketCustomersFetched(customers) {
    return {
        type: constants.TICKET_CUSTOMERS_FETCHED,
        customers: customers
    }
}

export function setTicketQuantity(articleNumber, quantity) {
    return {
        type: constants.SET_TICKET_QUANTITY,
        articleNumber: articleNumber,
        quantity: quantity
    }
}

export function toggleSelectedCustomer(customerId) {
    return {
        type: constants.TOGGLE_SELECTED_CUSTOMER,
        customerId: customerId
    }
}


// WEBPACK FOOTER //
// src/ticket/actions/ticketActions.js